import { render } from "./AppMenuFloat.vue?vue&type=template&id=34998b6a&scoped=true&ts=true&lang=pug"
import script from "./AppMenuFloat.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppMenuFloat.vue?vue&type=script&lang=ts&setup=true"

import "./AppMenuFloat.vue?vue&type=style&index=0&id=34998b6a&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34998b6a"]])

export default __exports__